import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconHvac = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconHvac",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M480-240q100 0 170-70t70-170-70-170-170-70-170 70-70 170 70 170 170 70m0-80q-29 0-56-10t-49-30h210q-22 19-49 30t-56 10m-138-80q-8-14-13-29t-7-31h316q-2 16-7 31t-13 29zm-20-100q2-16 7-31t13-29h276q8 14 13 29t7 31zm53-100q22-19 49-29t56-11 56 11 49 29zM200-120q-33 0-56-23t-24-57v-560q0-33 24-56t56-24h560q33 0 57 24t23 56v560q0 33-23 57t-57 23z"
  })
}));